<template>
  <section class="document-audience">
    <h2 class="document-audience__title" v-html="getTitleBlock(page, 'audience', 'title')"></h2>
    <div class="document-audience__grid">
      <article v-for="(item, index) in getListBlock(page, 'audience-list')" :key="index" class="document-audience__card">
        <span class="document-audience__icon"><component :is="icons[index] || 'UserCheckLineIcon'" /></span>
        <h3 class="document-audience__name" v-html="item.key"></h3>
        <p class="document-audience__text" v-html="item.value"></p>
      </article>
    </div>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { RESOURCE_AUDIENCE_ICONS } from '@/features/agent-resources/config';
import { UserCheckLineIcon } from '@/shared/ui/icons';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
  components: { UserCheckLineIcon },
  data() {
    return {
      icons: RESOURCE_AUDIENCE_ICONS,
    };
  },
};
</script>

<style lang="scss" scoped>
.document-audience {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  &__title {
    margin: 0 0 32px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.1;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    border-radius: 20px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: #EBF2FF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__name {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
  }

  &__text {
    margin: 0;
    font-size: 16px;
    line-height: 25px;
    color: #494E53;
  }
}
</style>
